import { useAssignOwfApplicationFunnelOptimizations, useSettingOwfApplicationFunnelOptimizations } from "@faire/retailer-visitor-shared/settings/useSettingOwfApplicationFunnelOptimizations";
import { useIsSoftCreditCheckApplication } from "./useIsSoftCreditCheckApplication";
import { HAS_SEEN_OWF_APPLICATION_FUNNEL_OPTIMIZATIONS } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_SEEN_OWF_APPLICATION_FUNNEL_OPTIMIZATIONS";
import { useEffect } from "react";
import { useRecordMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";

export const useIsOptimizedSCC = () => {
  const { isSoftCreditCheckApplication } = useIsSoftCreditCheckApplication();
  const isOwfApplicationFunnelOptimizations = useSettingOwfApplicationFunnelOptimizations();
  const assignOwfApplicationFunnelOptimizations = useAssignOwfApplicationFunnelOptimizations();
  const recordMilestone = useRecordMilestone();

  useEffect(() => {
    // only assign if SCC, given that XP (for this context) is SCC vs. SCC + App Funnel Optimizations
    // as opposed to other OWF flows (eg; non-SCC, NMI, etc)
    if (isSoftCreditCheckApplication) {
      if (isOwfApplicationFunnelOptimizations) {
        recordMilestone(HAS_SEEN_OWF_APPLICATION_FUNNEL_OPTIMIZATIONS);
      }
      
      assignOwfApplicationFunnelOptimizations();
    }
  }, [assignOwfApplicationFunnelOptimizations, isOwfApplicationFunnelOptimizations, isSoftCreditCheckApplication, recordMilestone]);

  return isSoftCreditCheckApplication && isOwfApplicationFunnelOptimizations;
};
